import { cachedAPIWrapper } from "../apiCaching/apiWrapper";
import { apiCaching } from "../config/cachingConfig";
import { Carousel } from "../util/infinty-scroll";
import { apiConfig } from "../config/apiConfig";
import { generateSvgDataUrl } from "../util/generateSvgDataUrl";
export class AnimatedTestimonialSection {
  parentElement!: HTMLElement;
  countryId!: 1 | 2;
  conceptId!: string;
  displayStars!: boolean;
  private topCarousel: Carousel | null = null;
  private bottomCarousel: Carousel | null = null;
  private isPaused: boolean = false;
  constructor(config: {
    parentElement: HTMLElement;
    countryId: 1 | 2;
    conceptId: string;
    displayStars: boolean;
  }) {
    const { parentElement, conceptId, countryId, displayStars } = config;
    this.displayStars = displayStars;
    this.parentElement = parentElement;
    this.conceptId = conceptId;
    this.countryId = countryId;
    this.init()
  }

  init() {
    const storedWebLocationId = localStorage.getItem("franchiseWebLocationId");
    const webLocationFromElement =
      (document.getElementById("weblocationId") as HTMLInputElement)?.value ||
      "";
    const weblocationId = storedWebLocationId ?? webLocationFromElement;
    const pageNumber = 1,
      pageSize = 30,
      rating = 5;
    const url =
      apiConfig.TESTIMONIAL_REVIEWS +
      `/${this.conceptId}/${weblocationId || 0}/${this.countryId}` +
      `/0/${pageNumber}/${pageSize}/${rating}`;
    this.fetchReviewData(url);
  }

  async fetchReviewData(url: string) {
    try {
      const response = (await cachedAPIWrapper(
        url,
        apiCaching.TestimonyAndReview
      )) as TestimonialData[];
      if (!Array.isArray(response)) {
        console.warn("Invalid testimonial response");
        return;
      }
      
      // Hide the entire section if response has less than 6 reviews
      if (response.length < 6) {
        const section = document.querySelector('.customer-review.reviews-animation-section');
        if (section) {
          (section as HTMLElement).style.display = 'none';
        }
        return;
      }
      
      this.filterData(response);
    } catch (e) {
      console.warn("Failed to fetch testimonial data", e);
    }
  }

  filterData(response: TestimonialData[]) {
    const validTestimonials = response.filter(
      (item) =>
        item.reviewBody &&
        item.reviewBody.trim().length > 0 &&
        item.reviewBody.length <= 300 &&
        item.reviewAuthorName
    );
    if (validTestimonials.length < 12) {
      const remainingItems = response.filter(
        (item) => !validTestimonials.includes(item) && item.reviewAuthorName
      );
      const additionalItems = remainingItems.slice(
        0,
        12 - validTestimonials.length
      );
      validTestimonials.push(...additionalItems);
    }
    const finalTestimonials = validTestimonials.slice(0, 12);
    
    // Split testimonials into equal parts for left and right content
    const splitPoint = Math.ceil(finalTestimonials.length / 2);
    const leftContent = finalTestimonials.slice(0, splitPoint);
    const rightContent = finalTestimonials.slice(splitPoint);
    
    this.generateHTML(leftContent, rightContent);
  }


  getReviewerData(data: TestimonialData): TestimonialData {
    const fullName: string = data.reviewAuthorName;
    const processedNameArray = fullName.match(/\b[a-zA-Z]+\b/g) as string[];
    let displayName = fullName;
    if (processedNameArray && processedNameArray.length === 1) {
      displayName = processedNameArray[0];
    }
    if (processedNameArray && processedNameArray.length >= 2) {
      displayName = `${processedNameArray[0]} ${processedNameArray[1]
        .charAt(0)
        .toUpperCase()}.`;
    }
    const newData = {
      ...data,
      reviewAuthorName: displayName,
      reviewBody: data.reviewBody ?? "No review provided.",
    };
    return newData;
  }

  createTemplate = (data: TestimonialData): string => {
    const star = `
        <span class="star full">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="20" height="20">
        <title>Star Icon</title>
        <desc>Star Icon</desc>
        <path fill="#FFC800" d="m48,234 73-226 73,226-192-140h238z"></path>
        </svg>
        </span>
        `;
    const reviewerData = this.getReviewerData(data);
    const generateCard = `
            <div class="card" >
            <div class="testimonial-wrapper">
                    <div class="testimonial-upper-content">
                        <div class="testimonal-client-image">
                            <img src="${reviewerData.reviewPhotoUrl}" 
                            onerror="this.onerror=null; this.src='${generateSvgDataUrl(
                              reviewerData.reviewAuthorName.charAt(0)
                            )}';">
                        </div>
                        <div class="testimonial-name-and-ratings-wrapper">
                            <p class="testimonial-client-name">${
                              reviewerData.reviewAuthorName
                            }</p>
                            ${
                              this.displayStars
                                ? `<div class="testimonial-ratings">
                                ${star} 
                                ${star} 
                                ${star} 
                                ${star}
                                ${star}
                            </div>`
                                : ""
                            }
                        </div>
                    </div>
                    <div class="testimonial-description">
                        ${reviewerData.reviewBody}
                    </div>
                </div>
            </div>
            `;
    return generateCard;
  };
  generateHTML(
    topContent: TestimonialData[],
    bottomContent: TestimonialData[]
  ) {
    //left cards
    const bottomCards = topContent.map(this.createTemplate).join("");
    let topCards =
      this.viewType == "desktop" || this.viewType == "tablet"
        ? bottomContent.map(this.createTemplate).join("")
        : null;
    //containers
    const bottomCarouselContainer = document.createElement("div");
    const topCarouselContainer =
      this.viewType == "desktop" || this.viewType == "tablet"
        ? document.createElement("div")
        : null;
    //container config
    bottomCarouselContainer.className = "carousel-container";
    bottomCarouselContainer.innerHTML = bottomCards;
    if (topCards && topCarouselContainer) {
      topCarouselContainer.className = "carousel-container";
      topCarouselContainer.innerHTML = topCards;
    }
    //parents
    const bottomCarouselParent = document.createElement("div");
    const topCarouselParent =
      this.viewType == "desktop" || this.viewType == "tablet"
        ? document.createElement("div")
        : null;
    //parents config
    if (topCarouselParent && topCarouselContainer) {
      topCarouselParent.className = "left-carousel-parent rtl";
      topCarouselParent.appendChild(topCarouselContainer);
      this.parentElement.appendChild(topCarouselParent);
    }

    bottomCarouselParent.className = "right-carousel-parent ltr";
    bottomCarouselParent.appendChild(bottomCarouselContainer);
    this.parentElement.appendChild(bottomCarouselParent);
    // Initialize and apply infinite scroll animation
    this.applyAnimation(bottomCarouselParent, topCarouselParent);
  }

  applyAnimation(
    bottomCarouselParent: HTMLElement,
    topCarouselParent: HTMLElement | null
  ) {
    try {
      const dataSpeed = this.parentElement.getAttribute('data-speed');
      let speed;
      switch (dataSpeed?.toLowerCase()) {
        case 'fast':
          speed = 1; break;
        case 'medium':
          speed = 0.5; break;
        case 'slow':
          speed = 0.1; break;
        default:
          speed = 0.5; break;
      }
      if(bottomCarouselParent) {
        this.bottomCarousel = new Carousel({
              selector: '.reviews-animation .right-carousel-parent',
              trackSelector: ".reviews-animation .right-carousel-parent .carousel-container",
              autoStart: true,
              speed,
              infinite: true,
              pauseDelay: 30000,
              direction: 'right2left',
              gap: 20,
        });
      }
      
      if (topCarouselParent) {
        this.topCarousel = new Carousel({
          selector: '.reviews-animation .left-carousel-parent',
            trackSelector: ".reviews-animation .left-carousel-parent .carousel-container",
            autoStart: true,
            speed,
            infinite: true,
            pauseDelay: 30000,
            direction: 'left2right',
            gap: 20,
        });
      }
      this.setupPauseResumeButton(); // Setup pause/resume button after carousel initialization
    } catch (e) {
      console.warn("Failed to apply animation", e);
    }
  }

  private setupPauseResumeButton() {
    const controlsDiv = document.querySelector('.review-animation-controls.carousel-cta')
    if(!controlsDiv) return;
    if(controlsDiv.classList.contains('hidden')) controlsDiv.classList.remove('hidden');
    const pauseResumeButton = document.querySelector('.review-animation-controls.carousel-cta .play-pause-btn');
    if (!pauseResumeButton) {
      console.warn('Pause/Resume button not found with selector: .review-animation-controls.carousel-cta .play-pause-btn');
      return;
    }
    pauseResumeButton.removeEventListener('click', this.handlePauseResumeClick); // remove existing event listener to prevent double click duplicates
    pauseResumeButton.addEventListener('click', this.handlePauseResumeClick);
  }

  private readonly handlePauseResumeClick = () => {
    if (this.isPaused) {
      if (this.topCarousel) {
        this.topCarousel.play();
      }
      if (this.bottomCarousel) {
        this.bottomCarousel.play();
      }
      this.isPaused = false;
    } else {
      if (this.topCarousel) {
        this.topCarousel.pause();
      }
      if (this.bottomCarousel) {
        this.bottomCarousel.pause();
      }
      this.isPaused = true;
    }
    this.togglePauseResumeElements();
  }

  togglePauseResumeElements(){
    const parentQuerySelector = '.review-animation-controls.carousel-cta .play-pause-btn'
    const [pauseSVG, playSVG] = document.querySelectorAll(`${parentQuerySelector} .play-icon, ${parentQuerySelector} .pause-icon`);
    if(!pauseSVG || !playSVG) return;
    const displayElement = !this.isPaused ? playSVG : pauseSVG;
    const hideElement = !this.isPaused ? pauseSVG : playSVG;
    if(displayElement.classList.contains('hidden')) displayElement.classList.remove('hidden');
    if(!hideElement.classList.contains('hidden')) hideElement.classList.add('hidden');
  }

  get viewType(): "tablet" | "desktop" | "mobile" {
    let view: "tablet" | "desktop" | "mobile" = "desktop";
    if (window.innerWidth < 426) view = "mobile";
    if (window.innerWidth < 781 && window.innerWidth > 425) view = "tablet";
    return view;
  }
}

window.addEventListener("DOMContentLoaded", () => {
  const reviewAnimationElement = document.querySelector(".reviews-animation");
  if (!reviewAnimationElement) return;
  reviewAnimationElement.innerHTML = "";
  const [countryIdElement, conceptIdElement] = document.querySelectorAll(
    "#countryCode, #conceptId"
  );
  if (!countryIdElement || !conceptIdElement) return;
  const countryId =
    (countryIdElement as HTMLInputElement)?.value.toLowerCase() == "us" ? 1 : 2;
  const conceptId = (conceptIdElement as HTMLInputElement).value;
  try {
    new AnimatedTestimonialSection({
      parentElement: reviewAnimationElement as HTMLElement,
      conceptId,
      countryId,
      displayStars: true,
    });
  } catch (e) {
    console.warn("Failed to load testimonial animation", e);
  }
});


type TestimonialData = {
  reviewPhotoUrl: string | null;
  reviewAuthorName: string;
  city?: string;
  reviewStarRating: number;
  reviewSourceType?: string;
  reviewBody?: string;
  reviewResponseBody?: string;
};
